export default [
  {
    name: 'available',
    label: 'Available',
    shortLabel: 'AVL',
    colour: 'green'
  },
  {
    name: 'on request',
    label: 'On Request',
    shortLabel: 'RQ',
    colour: 'orange'
  },
  {
    name: 'unavailable',
    label: 'Unavailable',
    shortLabel: 'N/A',
    colour: 'red'
  },
  {
    name: 'tbd',
    label: 'unknown',
    shortLabel: 'TBD',
    colour: 'white'
  }
]
